<template>
  <div class="tw-bg-white tw-rounded-lg tw-p-6 tw-mt-6">
    <Typography variant="headline-6">Hirefly recruiter notes </Typography>
    <Typography v-if="jobTitle" variant="subtitle-2" class="tw-pt-2">{{
      jobTitle
    }}</Typography>
    <Typography
      v-if="projectStatus.categoryName"
      variant="body-2"
      class="tw-pt-2"
    >
      {{ projectStatus.categoryName }}:
      {{ projectStatus.statusName }}</Typography
    >
    <div v-if="recruiterNotes?.mandatoryRequirements?.length" class="tw-mt-6">
      <Typography variant="subtitle-2"> Mandatory Requirements (P0)</Typography>
      <Typography variant="body-2">
        <ol>
          <li v-for="item in recruiterNotes.mandatoryRequirements" :key="item">
            {{ item }}
          </li>
        </ol>
      </Typography>
    </div>
    <div v-if="recruiterNotes?.additionalSuggestions?.length" class="tw-mt-6">
      <Typography variant="subtitle-2">
        Additional Suggestions (P1)
      </Typography>
      <Typography variant="body-2">
        <ol>
          <li v-for="item in recruiterNotes.additionalSuggestions" :key="item">
            {{ item }}
          </li>
        </ol>
      </Typography>
    </div>
    <div v-if="recruiterNotes?.tips?.length" class="tw-mt-6">
      <Typography variant="subtitle-2"> Tips </Typography>
      <Typography variant="body-2">
        <ol>
          <li v-for="item in recruiterNotes.tips" :key="item">
            {{ item }}
          </li>
        </ol>
      </Typography>
    </div>
    <div v-if="notes" class="tw-mt-6">
      <Typography variant="body-2">{{ notes }}</Typography>
    </div>
  </div>
</template>
<script>
import ClipBoard from '@/assets/img/clipboard-svgrepo-com.svg';
import constants from '@/js/constants';
import Typography from '@/components/v3/base/Typography';

export default {
  name: 'HardRequirements',
  components: { Typography },
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },

    notes: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      ClipBoard,
      show: false,
    };
  },

  computed: {
    projectStatus() {
      if (!this.projectData) return {};
      if (!this.projectData.operations_status) return {};
      return {
        categoryName:
          constants.OPERATIONS_STATUS[this.projectData.operations_status][0],
        statusName:
          constants.OPERATIONS_STATUS[this.projectData.operations_status][1],
        statusColor:
          constants.OPERATIONS_STATUS[this.projectData.operations_status][2],
      };
    },

    recruiterNotes() {
      if (!this.projectData || !this.projectData.recruiter_notes) {
        return {
          mandatoryRequirements: [],
          additionalSuggestions: [],
          tips: [],
        };
      }
      return {
        mandatoryRequirements:
          this.projectData.recruiter_notes.mandatory_requirements,
        additionalSuggestions:
          this.projectData.recruiter_notes.additional_suggestions,
        tips: this.projectData.recruiter_notes.tips,
      };
    },

    jobTitle() {
      return this.projectData?.name;
    },
  },

  unmounted() {
    this.show = false;
  },
};
</script>
